<template>
  <div>
    <b-card>
      <h4>Situação por Unidade Organizacional</h4>
      <b-card-body>
        <b-row class="align-items-center">
          <b-col sm="6" md="3" class="text-bold">
            Unidades Organizacionais:
          </b-col>
          <b-col sm="6">
            <organization-select
              v-model="search.organizations"
              :multiple="true"
              :show-label="false"
            />
          </b-col>
        </b-row>
        <b-row v-if="loading" style="height: 350px" class="text-center">
          <b-col sm="12" align-self="center">
            <i2-data-loading />
          </b-col>
        </b-row>
        <bar-chart
          v-if="!loading"
          :height="minHeight"
          :toolbar="true"
          :options="{
            xAxysGrid: true,
            yAxysGrid: true,
            dataLabels: true,
            yLabelFontSize: 10,
          }"
          :values="series"
          :y-label="yLabel"
          :is-horizontal="true"
          :is-stacked="true"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import I2DataLoading from '@/components/i2/layout/loading/I2DataLoading'
import BarChart from '@/components/i2/Graph/BarChart.vue'
import OrganizationSelect from '@/components/app/Organization/OrganizationSelect'

export default {
  name: 'SituationPerOrganizationGraph',
  components: {
    I2DataLoading,
    BarChart,
    OrganizationSelect,
  },
  data() {
    return {
      loading: false,
      series: {},
      minHeight: 300,
      search: {
        organizations: [],
      },
      dates: [],
      dateFilter: {
        deviceProvisioning: {
          startDate: null,
          endDate: null,
        },
      },
      deviceProvisioning: {
        dateRange: {
          startDate: null,
          endDate: null,
        },
      },
      yLabel: {
        text: 'Unidades',
        format: val => val,
      },
    }
  },
  watch: {
    'search.organizations': function (val) {
      this.getProvisioningHistory()
    },
  },
  created() {
    const today = new Date()
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1)
    this.dates = [startDate, today]
    this.setDateFilter(startDate, today)
    this.getProvisioningHistory()
    this.minHeight = 300
  },
  methods: {
    onSelect(values) {
      this.setDateFilter(values.startDate, values.endDate)
      this.getProvisioningHistory()
    },
    setDateFilter(startDate, endDate) {
      this.dateFilter.deviceProvisioning.startDate = `${startDate.getFullYear()}-${
        startDate.getMonth() + 1
      }-${startDate.getDate()}`
      this.dateFilter.deviceProvisioning.endDate = `${endDate.getFullYear()}-${
        endDate.getMonth() + 1
      }-${endDate.getDate()}`
    },

    getProvisioningHistory() {
      this.loading = true
      this.$http.showLoader = false
      const today = new Date()
      const dayString = `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()}`
      let unities = ''
      if (this.search.organizations) {
        unities = this.search.organizations.join(',')
      }

      const filter = `index=unities&dateInitial=2000-01-01&dateFinal=${dayString}`
      this.$http
        .get(`graph/situation-by-unity/data?${filter}&unities=${unities}`)
        .then(response => {
          this.series = response
          this.minHeight = 300
          if (this.series.series[0].data.length > 30) {
            this.minHeight = this.series.series[0].data.length * 30
          }
          this.loading = false
          this.$http.showLoader = true
        })
    },
  },
}
</script>

<style scoped></style>
